function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M0,0H14V14H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M8.524,2a6.524,6.524,0,1,0,6.524,6.524A6.526,6.526,0,0,0,8.524,2ZM7.871,13.7A5.211,5.211,0,0,1,3.3,8.524a5.3,5.3,0,0,1,.137-1.168l3.125,3.125v.652a1.309,1.309,0,0,0,1.3,1.3Zm4.5-1.657a1.294,1.294,0,0,0-1.239-.907h-.652V9.176a.654.654,0,0,0-.652-.652H5.914v-1.3h1.3a.654.654,0,0,0,.652-.652v-1.3h1.3a1.309,1.309,0,0,0,1.3-1.3V3.69a5.207,5.207,0,0,1,1.892,8.35Z",
  transform: "translate(-1.524 -1.524)",
  fill: "rgba(246,64,0,0.8)"
});

var SvgGlobe = function SvgGlobe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "public_black_24dp_1_",
    "data-name": "public_black_24dp (1)",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlobe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/globe.511c2d5f.svg";
export { ForwardRef as ReactComponent };